<template>
  <v-select
    :items="availableLocales"
    :model-value="locale"
    :class="cssClass ?? 'text-grey'"
    hide-details
    variant="underlined"
    density="compact"
    style="background: inherit"
    @update:model-value="(newLocale) => setLocale(newLocale)"
  >
    <template #selection="{ item }">
      <span class="text-body-small">
        <v-icon icon="language" />
        {{ $t(`languages.${item}`) }}
      </span>
    </template>

    <template #item="{ item, props }">
      <v-list-item v-bind="props" :title="$t(`languages.${item}`)" />
    </template>
  </v-select>
</template>

<script setup lang="ts">
const { cssClass = undefined } = defineProps<{ cssClass?: string }>()

const { locales, locale, setLocale } = useI18n()

const availableLocales = computed(
  (): Array<string> => locales.value.map((locale) => (typeof locale === "string" ? locale : locale.code.toString())),
)
</script>
